<template>
    <v-select
        hide-details
        outlined
        :append-icon="mdiChevronDown"
        dense
        :label="$t('sortBy')"
        :items="[
            { value: 'salesfrequency dynamic desc', text: $t('filterOrder.relevance') },
            { value: 'dateadded desc', text: $t('filterOrder.novelties') },
            { value: 'label asc', text: $t('filterOrder.ascendingAlphabet') },
            { value: 'label desc', text: $t('filterOrder.descendingAlphabet') },
            { value: 'price asc', text: $t('filterOrder.ascendingPrice') },
            { value: 'price desc', text: $t('filterOrder.descendingPrice') },
        ]"
        :placeholder="$t('filterOrder.relevance')"
        class="mr-3"
        v-model="order"
    />
</template>
<script lang="ts">
import { mdiChevronDown } from '@mdi/js';
import { Vue } from 'vue-property-decorator';
import { FINDOLOGICSearchAPIJSONResponse10 } from '../../../../declarations/result';
import { PropType } from 'vue';

export default Vue.extend({
    name: 'Order',
    props: {
        value: {
            type: String,
            default: '',
        },
        orderFromApi: {
            type: Object as PropType<FINDOLOGICSearchAPIJSONResponse10['request']['order']>,
            required: true,
        },
    },
    computed: {
        order: {
            get(): string {
                // When no order is specified as API parameter, the configured default order is used, which is only
                // visible to IF: PLP through the search API response, which mirrors whatever order is being used,
                // regardless of whether it's the request's, or a configured default.
                // Using this information, we can mark the right order as selected, even if the selection wasn't made
                // by the user.
                return this.value || this.flattenOrder(this.orderFromApi);
            },
            set(order: string): void {
                this.$emit('input', order);
            },
        },
    },
    data() {
        return {
            mdiChevronDown,
        };
    },
    methods: {
        flattenOrder(orderObj: FINDOLOGICSearchAPIJSONResponse10['request']['order']): string {
            return `${orderObj.field} ${orderObj.relevanceBased ? 'dynamic ' : ''}${orderObj.direction.toLowerCase()}`;
        },
    },
});
</script>
